import { render, staticRenderFns } from "./campaign_add_edit_dialog.vue?vue&type=template&id=5c72217c"
import script from "./campaign_add_edit_dialog.vue?vue&type=script&lang=ts"
export * from "./campaign_add_edit_dialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports